import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { Paginator } from '@app/shared/models/paginator/paginator';
import { Procedencia } from '@app/core/entities/procedencia/procedencia';
import { ProcedenciaInterface } from '@app/core/interfaces/procedencia-interface';
import { ProcedenciaType } from '@app/shared/helpers/enums/procedencia-relaciones-type.enum';
import { RespApi } from '@app/shared/helpers/interfaces/resp-api';
import { AuxiliarService } from '@app/shared/services/auxiliar/auxiliar.service';

@Injectable({
  providedIn: 'root'
})
export class ProcedenciasService {

  urlProcedencias       = environment.api_base_url + '/procedencias';

  public procedencias$: BehaviorSubject<Procedencia[]> = new BehaviorSubject<Procedencia[]>(null);
  public procedencia$: BehaviorSubject<Procedencia> = new BehaviorSubject<Procedencia>(null);
  public totalProcedencias$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  constructor(
    private http: HttpClient,
    private auxiliar: AuxiliarService
  ) { }

  set procedencia(procedencia: Procedencia) {
    this.procedencia$.next(procedencia);
  }

  set procedencias(procedencias: Procedencia[]) {
    this.procedencias$.next(procedencias);
  }

  getAll(paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<Procedencia[]> {
    let _filtros = filtros;
    if(!_filtros || _filtros && !filtros?.orden) {
      _filtros = {orden: 'nombre', tipoOrden: 'asc'};
    }
    return this.http.get(`${this.urlProcedencias}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(_filtros)}`, {}).pipe(
      tap( (data: RespApi )=> {this.totalProcedencias$.next( data.total );}),
      map((data: RespApi) => this.mapearProcedencias( data['data'])) ); 
  }

  mapearProcedencias( preocedencias: Procedencia[] ) {
    return preocedencias;
  }

  get(id): Observable<ProcedenciaInterface>{
    // return new Observable<ProcedenciaInterface>( observer => {
    //   observer.next(new Procedencia());
    //   observer.complete();
    // });
    return this.http.get(`${this.urlProcedencias}/${id}`).pipe(
      map((data: RespApi) => data['data'])
    );
  }

  create(procedencia: ProcedenciaInterface): Observable<any>{
    // return new Observable<ProcedenciaInterface>( observer => {
    //   observer.next(new Procedencia());
    //   observer.complete();
    // });
    return this.http.post(`${this.urlProcedencias}`, procedencia)
    .pipe(
      switchMap(data => {
        // TODO: Actualmente no está entrando por aqui ya que el interceptor de errores devuelve directamente el error
        if (data === 'error') {
          return throwError(new Error('Error'));
        } else {
          return of(data);
        }
      })
    );
  }


  // TODO borrar en cuanto devuelva el objeto correspondiente el get all procedncias
  private objetoRelacionadoToProcedenciaType( objeto: string ): ProcedenciaType {
    switch (objeto) {
      case ProcedenciaType.Colaboradores : 
        return ProcedenciaType.Colaboradores;
        break;
      case ProcedenciaType.BNI : 
        return ProcedenciaType.BNI;
        break;
      case ProcedenciaType.Campanhas : 
        return ProcedenciaType.Campanhas;
        break;
      case ProcedenciaType.Clientes : 
        return ProcedenciaType.Clientes;
        break;
      case ProcedenciaType.Comerciales : 
        return ProcedenciaType.Comerciales;
        break;
      case ProcedenciaType.Empleados : 
        return ProcedenciaType.Empleados;
        break;
      default:
        return null;
        break;
    }
  }



}
